import React, { useRef, useEffect, useState } from "react";
import AnalyticsIcon1 from "../../Assets/Logos/expenses/AnalyticsIcon1.png";
import AnalyticsIcon2 from "../../Assets/Logos/expenses/AnalyticsIcon2.png";
import AnalyticsIcon3 from "../../Assets/Logos/expenses/AnalyticsIcon3.png";
import AnalyticsIcon4 from "../../Assets/Logos/expenses/AnalyticsIcon4.png";
import dateIcon from "../../Assets/Logos/expenses/dateIcon.png";
import Cards from "../../components/AdminSideComponents/Cards";
import { MdAddCircle } from "react-icons/md";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoEye } from "react-icons/io5";
import deleteIcon from "../../Assets/Logos/checkout/deleteIcon.png";
import editIcon from "../../Assets/Logos/checkout/editIcon.png";
import AddExpenseModal from "../../components/AdminSideComponents/ExpenseSectionModals/AddExpenseModal";
import axios from "axios";
import { formatDate, truncateText } from "../../utils/dateFormat";
import DeleteConfirmationModal from "../../components/AdminSideComponents/ExpenseSectionModals/DeleteConfirmationModal";
import EditExpenseModal from "../../components/AdminSideComponents/ExpenseSectionModals/EditExpenseModal";
import ViewExpenseModal from "../../components/AdminSideComponents/ExpenseSectionModals/ViewExpenseModal";
import { GrView } from "react-icons/gr";
// import { FaFilter } from "react-icons/fa";

const expenses = [
  {
    Date: "12-03-1998",
    Category: "Accessories",
    Amount: "₹5602.00",
    Details:
      "Reference site about Lorem Ipsum, giving information on its origins",
  },
];

const Expenses = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // for search by buildingName and category
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;
  const [isAddExpenseModalOpen, setIsAddExpenseModalOpen] = useState(false); // initial close
  const [isDeleteExpenseModalOpen, setIsDeleteExpenseModalOpen] =
    useState(false);
  const [showDropdown, setShowDropdown] = useState(null);
  const dropdownRefs = useRef([]);
  const [expenseList, setExpenseList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [category, setCategory] = useState("");
  const [dropdownPosition, setDropdownPosition] = useState("down");
  const [isExpenseListChanged, setIsExpenseListChanged] = useState(false); // a state for create , delete , update  to sink with ui (refresh problem solution)
  const [selectedExpense, setSelectedExpense] = useState({});
  const [isEditExpenseModalOpen, setIsEditExpenseModalOpen] = useState(false);
  const [isViewExpenseModalOpen, setIsViewExpenseModalOpen] = useState(false);
  const [analyticsExpense, setAnalyticsExpense] = useState({});

  const items = [
    {
      name: "Expense till Date",
      numberOfItems: analyticsExpense?.totalExpense
        ? "₹" + analyticsExpense?.totalExpense
        : "₹0",
      icon: AnalyticsIcon1,
    },
    {
      name: "Year End Expense",
      numberOfItems: analyticsExpense?.yearEndExpense
        ? "₹" + analyticsExpense?.yearEndExpense
        : "₹0",
      icon: AnalyticsIcon2,
    },
    {
      name: "Previous Month Expense",
      numberOfItems: analyticsExpense?.previousYearExpense
        ? "₹" + analyticsExpense?.previousYearExpense
        : "₹0",
      icon: AnalyticsIcon3,
    },
  ];

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 200 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  // for toggle of dropdown
  // const toggleDropdown = (index) => {
  //   setShowDropdown(showDropdown === index ? null : index);
  // };

  // for closing and opening add expense modal
  const closeAddExpenseModal = () => {
    setIsAddExpenseModalOpen(false);
  };

  const openAddExpenseModal = () => {
    setIsAddExpenseModalOpen(true);
  };

  // for pagination prev and next button logic
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getAnalyticsExpenses = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/expense/getanalyticsexpense`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> Analytics Expenses ", response.data);
        setAnalyticsExpense(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAnalyticsExpenses();
  }, [isExpenseListChanged]);

  const getAllExpenseList = async function () {
    setLoading(true);

    console.log("startDate", startDate);
    console.log("endDate", endDate);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/expense/getallexpenses?page=${currentPage}&limit=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}&buildingName=${searchQuery}&category=${category}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------> expenses ", response.data);
        setExpenseList(response.data.data);
        setLoading(false);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllExpenseList();
  }, [currentPage, isExpenseListChanged, startDate, endDate, category]);

  useEffect(() => {
    getAllExpenseList();
  }, [searchQuery]);

  return (
    <div className="expenseConatinaer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Expenses
      </h1>
      <Cards items={items} />
      <div className="p-4  bg-white shadow-lg mt-6 rounded-lg overflow-hidden ">
        <div className="flex w-full  overflow-hidden justify-evenly flex-wrap md:flex-nowrap  md:justify-between items-center gap-4  mb-4">
          <h1 className="text-[18px] flex justify-between w-full  items-center  md:w-56  text-primaryTextColor sm:text-[24px] font-bold">
            Expenses List
            <MdAddCircle
              onClick={openAddExpenseModal}
              className="rounded-lg  md:hidden cursor-pointer   text-primaryColor"
              size={40}
            />
          </h1>

          <div className="flex w-full flex-col gap-2 sm:flex-row justify-between overflow-hidden">
            <div class="flex items-center  w-full  sm:w-fit p-1  md:p-2  border border-gray-300">
              <input
                type="date"
                name="startDate"
                // value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                class="w-[50%] md:w-full  rounded-lg  focus:outline-none "
                placeholder="Start Date"
              />
              <input
                type="date"
                name="endDate"
                // value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                class="w-[50%] md:w-full  rounded-lg  focus:outline-none "
                placeholder="End Date"
              />
            </div>
            <div className="flex gap-2 ">
              <div className="relative w-full">
                <select
                  name="category"
                  id="category"
                  onChange={(e) => setCategory(e.target.value)}
                  className="border border-gray-300 w-full rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                >
                  <option value="" selected>
                    Select Category
                  </option>
                  <option value="Electricity Bill">Electricity Bill</option>
                  <option value="Internet Bill">Internet Bill</option>
                  <option value="Maintenance">Maintenance</option>
                  {/* <option value="Security Return">Security Return</option> */}
                  <option value="Employee Salary">Employee Salary</option>
                  {/* <option value="Rent">Rent</option> */}
                  <option value="Housekeeping">Housekeeping</option>
                  <option value="Transport">Transport</option>
                  <option value="Staff Advance">Staff Advance</option>
                  <option value="Staff Salary">Staff Salary</option>
                  <option value="Staff Food">Staff Food</option>
                  <option value="Promotions">Promotions</option>
                  <option value="Miscellaneous">Miscellaneous</option>
                </select>
              </div>
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search..."
                  className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                  value={searchQuery}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchQuery(e.target.value);
                  }}
                />
                <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

                {searchQuery && (
                  <FaTimes
                    onClick={() => setSearchQuery("")}
                    className="absolute top-4 right-3 text-secondaryTextColor cursor-pointer"
                  />
                )}
              </div>

              <MdAddCircle
                onClick={openAddExpenseModal}
                className="rounded-lg cursor-pointer flex-shrink-0 hidden md:block text-primaryColor"
                size={40}
              />
            </div>
          </div>
        </div>

        <div className="overflow-x-auto min-h-[70vh]">
          <table className="min-w-full bg-white  border-gray-200 rounded-md  ">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-14 xl:px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Date
                </th>
                <th className="py-3 px-14 text-nowrap xl:px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Building Name
                </th>

                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Category
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Amount
                </th>
                <th className="py-3  px-24 xl:px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Details
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide ">
              {loading ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 flex justify-center px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 flex justify-center px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-4/4"></div>
                    </td>
                    <td className="py-4 flex justify-center px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                  </tr>
                ))
              ) : expenseList.length > 0 ? (
                expenseList.map((data, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 text-nowrap px-6 text-sm text-center text-primaryTextColor">
                      {data?.date?.slice(0, 10)}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.buildingName?.nameBuilding || "N/A"}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.category}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.amount}
                    </td>
                    <td className="py-4 px-6 text-sm text-left text-primaryTextColor">
                      {truncateText(data?.description, 10)}
                    </td>

                    <td className="py-4 px-6 text-sm text-center hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                      <div
                        className="relative"
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div
                            className={`absolute  ${
                              dropdownPosition === "up" && index != 0
                                ? "bottom-5 mb-2"
                                : "top-5 mt-2"
                            } right-0 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-30`}
                          >
                            <ul className="py-1">
                              <li
                                onClick={() => {
                                  // Handle View Action
                                  setSelectedExpense(data);
                                  setIsViewExpenseModalOpen(true);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <IoEye size={20} className="text-blue-500" />
                                View
                              </li>
                              <li
                                onClick={() => {
                                  // Handle Edit Action
                                  setSelectedExpense(data);
                                  setIsEditExpenseModalOpen(true);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="edit"
                                />{" "}
                                Edit
                              </li>
                              <li
                                onClick={() => {
                                  // Handle Delete Action
                                  setSelectedExpense(data);
                                  setIsDeleteExpenseModalOpen(true);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="delete"
                                />{" "}
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    className=" px-6  text-center w-full text-secondaryTextColor h-[70vh] text-lg font-mediun"
                  >
                    No expenses found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalExpenses)} of{" "}
            {pagination.totalExpenses}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
      <AddExpenseModal
        changeListAgain={() => setIsExpenseListChanged((prev) => !prev)}
        isOpen={isAddExpenseModalOpen}
        onClose={closeAddExpenseModal}
      />
      <EditExpenseModal
        isOpen={isEditExpenseModalOpen}
        onClose={() => setIsEditExpenseModalOpen(false)}
        expense={selectedExpense}
        changeListAgain={() => setIsExpenseListChanged((prev) => !prev)}
      />
      <ViewExpenseModal
        isOpen={isViewExpenseModalOpen}
        data={selectedExpense}
        onClose={() => setIsViewExpenseModalOpen(false)}
      />
      <DeleteConfirmationModal
        currentExpense={selectedExpense}
        changeListAgain={() => setIsExpenseListChanged((prev) => !prev)}
        isOpen={isDeleteExpenseModalOpen}
        onClose={() => setIsDeleteExpenseModalOpen(false)}
      />
    </div>
  );
};

export default Expenses;

// const AddExpenseModal = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   const handleAddExpense = (e) => {
//     e.preventDefault();

//     // do the necessary api calls

//     alert("Add Expense done");
//     // close the modal
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//       <div className="relative h-[31rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
//         {/* Modal Header */}
//         <div className="mb-6">
//           <h2 className="text-2xl font-semibold text-center">Add Expense</h2>
//           <AiFillCloseCircle
//             onClick={onClose}
//             className="cursor-pointer  text-primaryColor absolute top-4 right-4"
//             size={30}
//           />
//         </div>

//         {/* Modal Content */}
//         <form
//           onSubmit={handleAddExpense}
//           className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4"
//         >
//           <div>
//             <label
//               htmlFor="issueTitle"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Date
//             </label>

//             <input
//               id="date"
//               type="date"
//               className="mt-1 p-3 block  w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md"
//             />
//           </div>

//           <div>
//             <label
//               htmlFor="Category"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Category
//             </label>
//             <select
//               id="Category"
//               name="Category"
//               className="mt-1 p-3 block w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md"
//             >
//               <option value="" disabled selected>
//                 Select
//               </option>
//               <option value="amenities">Amenities</option>
//               <option value="food">Food</option>
//               <option value="electrical">Electrical</option>
//               <option value="plumbing">Plumbing</option>
//               <option value="pests">Pests</option>
//               <option value="cleaning">Cleaning</option>
//               <option value="bed">Bed</option>
//               <option value="security">Security</option>
//               <option value="power">Power</option>
//               <option value="internet">Internet</option>
//               <option value="miscellaneous">Miscellaneous</option>
//             </select>
//           </div>
//           <div>
//             <label
//               htmlFor="Amount"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Amount
//             </label>
//             <input
//               type="text"
//               id="Amount"
//               placeholder="Amount"
//               className="mt-1 p-3 block  w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md"
//             />
//           </div>
//           <div>
//             <label
//               htmlFor="Details"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Details
//             </label>
//             <input
//               type="text"
//               id="Details"
//               placeholder="Details"
//               className="mt-1 p-3 block  w-full border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md"
//             />
//           </div>

//           {/* Buttons */}
//           <div className="sm:col-span-2  flex justify-between gap-6 mt-6 tracking-wide">
//             <button
//               onClick={onClose}
//               type="button"
//               className="bg-white w-full border text-xs sm:text-lg hover:bg-secondaryTextColor px-4 py-2 rounded-md"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="bg-primaryBtnColor text-xs sm:text-lg hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
//             >
//               Add Expense
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };
